// extracted by mini-css-extract-plugin
export var barContainer = "_2y-0";
export var extraThin = "_2y-3";
export var fillBar = "_2y-6";
export var fillContainer = "_2y-4";
export var overflow = "_2y-8";
export var overflowContainer = "_2y-5";
export var regular = "_2y-7";
export var thick = "_2y-1";
export var thin = "_2y-2";